import "./OurProcess.module.css";
import Header from "@/reusable_sections/Header";
import TheRoadmapToJuniorCollege from "./sections/TheRoadmapToJuniorCollege";
import AdvancementServices from "./sections/AdvancementServices";
import Footer from "@/reusable_sections/Footer";
export default function OurProcessPage() {
  return <div>
      <Header />
      <TheRoadmapToJuniorCollege />
      <AdvancementServices />
      <Footer />
    </div>;
}